import { VerifyEmailContent } from './VerifyEmailContent';

// Required for static export with dynamic routes
// Returns empty array to indicate no pre-rendering (client-side routing only)
export async function generateStaticParams() {
    return [];
}

export default function VerifyEmailPage() {
    return <VerifyEmailContent />;
}
